import React, { ReactElement } from 'react';
import { Typography } from 'antd';
import { Chart, VizState } from '@threatadvisor/react-components';

export type DetectionCasesByAlertTypeProps = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
};

export default function DetectionCasesByAlertType(
  props: DetectionCasesByAlertTypeProps
): ReactElement {
  const { clientUid, reportStart, reportEnd } = props;

  const escalatedEventsByName = (): VizState => {
    return {
      chartType: 'bar',
      pivotConfig: {
        x: ['DetectionsExtended.first_security_event'],
        y: ['measures'],
        fillMissingDates: true
        //"joinDateRange": false
      },
      query: {
        measures: ['DetectionsExtended.count'],
        order: {
          'DetectionsExtended.count': 'desc'
        },
        filters: [
          {
            member: 'DetectionsExtended.client_uid',
            operator: 'equals',
            values: [clientUid]
          },
          {
            member: 'DetectionsExtended.priority',
            operator: 'notEquals',
            values: ['P5', '5']
          }
        ],
        limit: 20,
        dimensions: ['DetectionsExtended.first_security_event'],
        timeDimensions: [
          {
            dimension: 'DetectionsExtended.created_date',
            dateRange: [reportStart, reportEnd]
          }
        ]
      }
    };
  };

  return (
    <>
      <h2 className="text-uppercase">Top Detection Cases By Alert Type</h2>

      <figure>
        {' '}
        <Chart
          hideCubeName
          useGridTable
          noTitleTranslation
          useHeightBasedOnHowManyItems
          wrapCategoryAxisLabel={true}
          chartConfig={{
            legend: false
          }}
          config={escalatedEventsByName()}
        />
        <figcaption>
          <Typography.Text type="secondary">
            Shows top 20 cases escalated to client by type of alert.
          </Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
